import {BusinessCaseType} from '@dms/api/sales';

import {KanbanSettings} from '../types/KanbanSettings';

export const isColumnVisible = (
  settings: KanbanSettings,
  businessCaseType: BusinessCaseType,
  columnValue: string
) => {
  // Only access the first element of visibleColumns array as the current API
  // contract supports only a single columns configuration
  return Boolean(settings.visibleColumns?.[0]?.[businessCaseType]?.[columnValue]);
};
